import { renderRichText } from '@richtext'

export const richTextToComponents = (content, options) => {
  if (!content) return null
  if (Object.keys(content).length === 0) return null

  return renderRichText(content, options)
}
